export type EventImportantDetailSlug =
  | 'included'
  | 'bring'
  | 'people'
  | 'locationSummary'
  | 'courseTarget'

/** First block above the buy box on desktop (and all items on mobile). */
export const EVENT_IMPORTANT_DETAIL_PRIMARY_ITEMS: EventImportantDetailSlug[] =
  ['included', 'bring']

/** Remaining items shown below the buy box on desktop only. */
export const EVENT_IMPORTANT_DETAIL_SECONDARY_ITEMS: EventImportantDetailSlug[] =
  ['people', 'locationSummary', 'courseTarget']

export const EVENT_IMPORTANT_DETAIL_ALL_ITEMS: EventImportantDetailSlug[] = [
  ...EVENT_IMPORTANT_DETAIL_PRIMARY_ITEMS,
  ...EVENT_IMPORTANT_DETAIL_SECONDARY_ITEMS,
]
